"use client";

import { useIsMobile } from "@marketing-sites/hooks/use-mobile";
import { cn } from "@marketing-sites/utils/cn";
import { Variants } from "motion/react";
import * as m from "motion/react-m";

type BarProps = {
  label: string;
  value: number;
  barClassName: string;
};

const BAR_VARIANTS: Variants = {
  hidden: {
    scaleY: 0,
  },
  visible: (duration: number) => ({
    scaleY: 1,
    transition: {
      duration,
    },
  }),
};

const TEXT_VARIANTS: Variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: {
      delay: 0.8,
      duration: 1,
    },
  },
};

export const Bar = ({ label, value, barClassName }: BarProps) => {
  const isMobile = useIsMobile();
  const duration = isMobile ? 0.6 : 1;

  return (
    <div className="bg-report-grey-100 flex h-full min-w-0 flex-1 flex-col">
      <span className="text-report-detail-mobile lg:text-report-body-small block p-1 uppercase">
        {label}
      </span>

      <div className="flex h-full flex-1 flex-col justify-end">
        <m.div
          className={cn("order-2 min-w-0 origin-bottom", barClassName)}
          variants={BAR_VARIANTS}
          custom={duration}
          style={{ height: `${value}%` }}
        />
        <m.span
          variants={TEXT_VARIANTS}
          className="text-report-h3-mobile xl:text-report-h3 order-1 mb-px block"
        >
          {value}%
        </m.span>
      </div>
    </div>
  );
};
